module.exports = __webpack_public_path__ + "assets/img/cb92bc25952664b612c4194c82467283.png";